import { PageHeader } from "antd";
import LayoutCss from "layout/layout.module.scss";
import { JobsContainer } from "./jobsContainer/jobsContainer";

export const Jobs = () => (
  <>
    <PageHeader
      ghost={false}
      title="Jobs"
      className={LayoutCss.appPageHeader}
    />
    <JobsContainer />
  </>
);
